import React, { useState } from 'react'
import Modal from '../../Modal/Modal'

export default function DeleteTagModal({ tag, onClose, onConfirm }) {
  const [deleting, setDeleting] = useState(false)

  const confirm = () => {
    setDeleting(true)
    onConfirm().finally(() => setDeleting(false))
  }

  return (
    <Modal isOpen={!!tag} onClose={onClose}>
      <Modal.Header>
        <span className="font-bold text-lg dark:text-white">Delete tag</span>
      </Modal.Header>
      <Modal.Body>
        <div className="w-[440px] text-sm text-rb-black dark:text-white">
          <p>Delete <span className="font-semibold">{tag?.name}</span>?</p>
          <p className="mt-2 text-gray-600 dark:text-gray-300">
            {tag?.creators_count
              ? `It will be removed from ${tag.creators_count} creator${tag.creators_count === 1 ? '' : 's'} (${tag.accounts_count} account${tag.accounts_count === 1 ? '' : 's'}). This cannot be undone.`
              : 'No creator uses this tag. This cannot be undone.'}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-between items-center">
          <Modal.DissmissButton className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg">
            Cancel
          </Modal.DissmissButton>
          <button
            type="button"
            disabled={deleting}
            onClick={confirm}
            className="px-4 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50"
          >
            {deleting ? 'Deleting...' : 'Delete tag'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
